import React, {useCallback, useEffect, useRef, useState} from 'react';
import ReactFlow, {
    addEdge,
    Background,
    ConnectionLineType,
    Controls,
    getOutgoers,
    MarkerType,
    MiniMap,
    ReactFlowProvider,
    useEdgesState,
    useNodesState
} from 'react-flow-renderer';
import Sidebar from './leftSideBar';
import './reactFlow.css';
import {
    Box,
    Button,
    Flashbar,
    FlashbarProps,
    Form,
    FormField,
    Grid,
    Input, Select,
    SpaceBetween
} from "@amzn/awsui-components-react-v3";
import {getAwsCredentials} from "src/authentication/cognito";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {INPUT_TYPE_OPTIONS} from "src/pages/reactflow/reactFlowConstants";
import {nodes1, edges1, defaultEdgeOptions, nodeTypes, getId} from "src/pages/reactflow/reactFlowUtils"


const AWS = require("aws-sdk");



const DnDFlow = () => {
    const taskDetails = useRef(null);
    const [objectEdit, setObjectEdit] = useState<any>([]);
    const reactFlowWrapper = useRef<HTMLInputElement>(null);
    const [reactFlowInstance, setReactFlowInstance] = useState<any>(null);
    const [isVisible, setIsVisible] = useState(false);
    const [tasks, setTasks] = useState<any>([])
    const [formattedData, setFormattedData] = useState<any>(null)
    const [edgesDetails, setEdgesDetails] = useState<any>([])
    const [ flashBarItems, setFlashBarItems ] = useState<FlashbarProps.MessageDefinition[]>([]);
    const [nodes, setNodes, onNodesChange] = useNodesState(nodes1);
    const [edges, setEdges, onEdgesChange] = useEdgesState(edges1);
    const [type, setType] = useState<{ label: string; value: string }>( { label: "", value: "" });

    const Location = useLocation();
    const urlParams = queryString.parse(Location.search);
    const workflowName = urlParams["workflow_name"] as string;


    const convertToExport = () => {
        nodes.forEach((elem)=>{
            const detail = getOutgoers(elem, nodes, edges)
            const edgeDetail = {}
            const outgoers: string[] = []
            detail.forEach((det) =>{
                outgoers.push(det.id)
            })
            edgeDetail[elem.id] = outgoers
            console.log(edgeDetail)
            setEdgesDetails((edgesDetails) => edgesDetails.
            concat(edgeDetail))
        })

    }

    const convertToExportFormat = () => {

        setFlashBarItems([{
            "header": " Submitting workflowDetails ",
            "type": "success",
            "loading": true,
            "dismissible": true,
            onDismiss: () => setFlashBarItems([])
        }]);

        convertToExport()
        let formattedDataJson = { nodes: {}, edges: {} }
        let formattedTaskDataJson = { tasks: {}, edges: {} }
        let i = 0
        let j = 0
        let k = 0
        nodes.forEach((elem) => {
            if (elem.data.label != "Start" && elem.data.label != "End") {
                formattedDataJson.nodes[i] = elem
                i = i + 1;
            }

        })
        edges.forEach((ele) => {
            formattedDataJson.edges[j] = ele
            formattedTaskDataJson.edges[j] = ele
            j = j+1;
        })
        tasks.forEach((ele => {
            formattedTaskDataJson.tasks[k] = ele
            k=k+1;
        }))
        setFormattedData(formattedDataJson);
    }


    useEffect(() => {invokeLambda()}, [formattedData, edgesDetails])

    const invokeLambda = async() => {
        console.log(JSON.stringify(formattedData))
        try {
            await getAwsCredentials();
            const lambdaClient = new AWS.Lambda({apiVersion: '2015-03-31',region:'us-east-1'});
            if(formattedData) {
                var params = {
                    FunctionName: "testLambda",
                    Payload: JSON.stringify({
                        workflowName: workflowName,
                        nodes: formattedData.nodes,
                        edges: edgesDetails

                    }),
                };
                console.log("lambda is invoked")
                await lambdaClient.invoke(params).promise();
                setFlashBarItems([{
                    "header": `Successfully Submitted the workflowDetails! \n 
                    visit https://test.snow.aft.amazon.dev/#/requirementsPage?workflow_name=${workflowName} for submitting entity details`,
                    "type": "success",
                    "dismissible": true,
                    onDismiss: () => setFlashBarItems([])
                }]);
                setNodes(nodes1)
                setEdges(edges1)
            }
        } catch(e) {
            console.log(e);
            throw e;
        }
    }

    const onConnect = useCallback(
        (params) =>
            setEdges((eds) =>
                addEdge(
                    {
                        ...params,
                        type: "default",
                        style: { strokeWidth: 1, stroke: "grey", float: true },
                        markerEnd: {
                            type: MarkerType.ArrowClosed,
                            strokeWidth: 1,
                            color: "grey",
                        }
                    },
                    eds
                )
            ),
        [setEdges]
    );

    const onNodeClick = (event, object) => {
        object.style = {
            color: "red"
        }
        if(object.name == 'Start' || object.name == 'End') {
            setIsVisible(false);
            return
        }
        setIsVisible(true);
        setObjectEdit(object);

    };

    const onPaneClick = () => {
        setIsVisible(false);
        setObjectEdit({});
    };

    const handleChange = (object, key, value) => {

        if(key.includes("_input_type")){
            console.log(value)
            setType(value as { label: string; value: string })
            object.mappings[key] = value.value
        } else {
            if (key == 'name') {
                object.taskName["name"] = value
                object.data["label"] = value;
            } else {
                object.mappings[key] = value;
            }
        }

        setObjectEdit({...object})

    }


    const submitMappingDetails = () => {
        setObjectEdit({...objectEdit})
    }

    const onDragOver = useCallback((event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = "move";
    }, []);

    const onDrop = useCallback(
        (event) => {
            event.preventDefault();
            if(reactFlowWrapper.current ===null) {
                return;
            }
            const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
            const node = JSON.parse(event.dataTransfer.getData('application/reactflow'))
            const { type, name, inputFields, output, endpoint, toolName, displayName} = node


            if (typeof type === "undefined" || !type) {
                return;
            }

            const position = reactFlowInstance.project({
                x: event.clientX - reactFlowBounds.left,
                y: event.clientY - reactFlowBounds.top
            });
            const newNode = {
                id: getId(),
                type: `${type}`,
                name: `${name}`,
                inputFields: inputFields,
                output: {output},
                endpoint: `${endpoint}`,
                position,
                data: { label: `${displayName}` },
                mappings: {},
                toolName: toolName,
                taskName: {}
            };

            const newTask = {
                id: getId(),
                name: `${name}`,
                inputFields: inputFields,
                output: {output},
                endpoint: `${endpoint}`,
                mappings: {}
            }

            setTasks((tasks) => tasks.concat(newTask))
            setNodes((nds) => nds.concat(newNode));
        },
        [reactFlowInstance, setNodes]
    );



    return (
        <div>
            <Flashbar items={[...flashBarItems]} />
            <Box variant="div" margin={{ top: "l" }}>
                <Grid gridDefinition={[{ colspan: 3 }, { colspan: 6 }, { colspan: 3 }]}>
                    <div style={{ height: "100vh", width:"100%"}}>
                        <Sidebar/>
                    </div>
                    <div style={{ height: "95vh", width:"100%"}} ref={reactFlowWrapper}>
                        { isVisible ?
                            <SpaceBetween size="xs">
                                <div>
                                    <Button onClick={convertToExportFormat}  variant="primary" className="button">
                                        Submit Workflow
                                    </Button>
                                </div>
                            </SpaceBetween>  : null
                        }
                        <ReactFlow
                            nodes={nodes}
                            edges={edges}
                            nodeTypes={nodeTypes}
                            onNodesChange={onNodesChange}
                            defaultEdgeOptions={defaultEdgeOptions}
                            onEdgesChange={onEdgesChange}
                            onConnect={onConnect}
                            onInit={setReactFlowInstance}
                            onDrop={onDrop}
                            onDragOver={onDragOver}
                            onNodeClick={onNodeClick}
                            onPaneClick={onPaneClick}
                            fitView
                            attributionPosition="bottom-left"
                            connectionLineType={ConnectionLineType.SmoothStep}

                        >
                        <MiniMap />
                        <Controls/>
                        <Background color="#aaa" gap={16} />
                        </ReactFlow>
                    </div>
                    { isVisible ?
                        <div className="sideArea" ref={taskDetails}>
                            <div className="nodeDetails">
                                <h2>Enter details for {objectEdit.name}</h2>
                                {objectEdit.inputFields ?
                                    <Form>
                                        <SpaceBetween size="xs">
                                            <FormField label="TaskName">
                                                <Input
                                                    type="text"
                                                    value={objectEdit.taskName["name"]}
                                                    onChange={({detail}) =>
                                                        handleChange(objectEdit, "name", detail.value)
                                                    }
                                                ></Input>
                                            </FormField>
                                            <h6> Enter $ for the fields needs to be filled by the workflow user </h6>
                                            { objectEdit.inputFields.map((field => {
                                                return <div> <SpaceBetween size="xs">
                                                    <FormField key = {field} label={field}>
                                                        <Input
                                                            type="text"
                                                            value={objectEdit.mappings[field]}
                                                            onChange={({ detail }) =>
                                                                handleChange(objectEdit, field, detail.value)
                                                            }
                                                        ></Input>
                                                    </FormField>
                                                    {objectEdit.mappings[field] && objectEdit.mappings[field].includes('$')?
                                                        <SpaceBetween size="xs">
                                                            <div>
                                                                <FormField key = {field+objectEdit.mappings[field]} label={field+"_input_type"}>
                                                                    <Select
                                                                        selectedOption={type}
                                                                        onChange={({ detail }) =>
                                                                            handleChange(objectEdit, field+"_input_type", detail.selectedOption)
                                                                        }
                                                                        options={INPUT_TYPE_OPTIONS}
                                                                        selectedAriaLabel="Selected"
                                                                    />
                                                                    {type.value == "select" ?
                                                                        <FormField key = {objectEdit.mappings[field]} label={field+"_input_options"}>
                                                                        <Input
                                                                            type="text"
                                                                            value={objectEdit.mappings[field+"_input_options"]}
                                                                            onChange={({ detail }) =>
                                                                                handleChange(objectEdit, field+"_input_options", detail.value)
                                                                            }
                                                                        ></Input>
                                                                    </FormField> :null}

                                                                </FormField>
                                                                <FormField key = {objectEdit.mappings[field]} label={field+"_input_desc"}>
                                                                    <Input
                                                                        type="text"
                                                                        value={objectEdit.mappings[field+"_input_desc"]}
                                                                        onChange={({ detail }) =>
                                                                            handleChange(objectEdit, field+"_input_desc", detail.value)
                                                                        }
                                                                    ></Input>
                                                                </FormField>
                                                            </div></SpaceBetween >
                                                        :null
                                                    }
                                                </SpaceBetween> </div>
                                            }))}
                                            <div>
                                                <Button
                                                    onClick={submitMappingDetails}
                                                    variant="primary"
                                                    className="button"
                                                >
                                                    Submit
                                                </Button>
                                            </div>
                                        </SpaceBetween>
                                    </Form> :null }
                            </div>
                        </div> :
                        <SpaceBetween size="xs">
                            <div>
                                <Button onClick={convertToExportFormat}  variant="primary" className="button">
                                    Submit Workflow
                                </Button>
                            </div>
                        </SpaceBetween>  }
                </Grid>
            </Box>
        </div>
    );
};

function DnDFlowProvider(props) {
    return (
        <div>

            <ReactFlowProvider>
                <DnDFlow {...props} />
            </ReactFlowProvider>
        </div>
    );
}

export default DnDFlowProvider;


